import Vue from 'vue';
import iView from 'iview';
import axios from 'axios';
import {Message} from 'iview'
import {
  router
} from '@/router';
import CONFIG from '@/config';

Vue.use(iView);

const NetUtils = {

  /**
   * AJAX请求
   * @param extendConfig        @配置属性
   */
  ajaxRequest(extendConfig, successCallBack, failCallBack, isJSON = false) {

    const baseConfig = {

      baseURL: '',

      method: "GET",

      needNotice: true,

      headers: {

        'Content-Type': isJSON ? 'application/json' : 'application/x-www-form-urlencoded'

      }

    };

    const AssignData = Object.assign({}, baseConfig, extendConfig);

    const instance = axios.create(AssignData);

    const successCallBackFunc = successCallBack || undefined;

    const FailCallBackFunc = failCallBack || function (err) { };

    instance.interceptors.response.use(function(res) {
      return res
    }, function(err) {
      if (err.response) {
        Message.error({
          content: `code：${err.response.data.code}, message: ${err.response.data.message}`,
        })
      }
      return Promise.reject(err)
    })

    instance().then((res) => {

      res.data.code = parseInt(res.data.code);
      // console.log(res)

      if (res.data instanceof Blob) {

        successCallBackFunc(res.data);

      } else if (res.data.code === CONFIG.CALLBACK_CODE.SUCCESS) {

        successCallBackFunc(res.data);

      } else if (res.data.code === CONFIG.CALLBACK_CODE.VALIDATE_ERROR) {
        // console.log(res.data.code === CONFIG.CALLBACK_CODE.VALIDATE_ERROR)
        if (res.data.data) {
          const errorDataArr = Object.keys(res.data.data);

          errorDataArr.forEach(errorItem => {
            iView.Notice.error({
              desc: res.data.data[errorItem],
              duration: 5
            });
          });
        } else {
          iView.Notice.error({
            desc: res.data.message,
            duration: 5
          });
        }
        
        FailCallBackFunc(res.data);

      } else if (res.data.code === CONFIG.CALLBACK_CODE.AUTH_FAIL && res.data.module === 'cfb-admin-service') {

        iView.Modal.confirm({
          title: '用户认证失效',
          content: res.data.message,
          okText: '前往登录',
          cancelText: '留在本页',
          closable: true,
          onOk() {
            localStorage.removeItem('userInfo');
            router.push('/login');
          }
        });

      } else if (res.data.code === CONFIG.CALLBACK_CODE.LOGIN_FAIL && res.data.module === 'cfb-admin-service') {

        iView.Modal.error({
          title: res.data.message,
          content: res.data.data.message,
          closable: true
        });

      } else if (res.data.code === CONFIG.CALLBACK_CODE.EXCEL_FORMAT_ERROR) {

        iView.Notice.open({
          desc: res.data.data.message,
          duration: 4,
          onClose() { FailCallBackFunc(res.data); }
        });

      } else {

        AssignData.needNotice ? iView.Notice.error({
          desc: res.data.message,
          duration: 4,
          onClose() { FailCallBackFunc(res.data); }
        }) : FailCallBackFunc(res.data);

      }

    }).catch(function (err) {
      // 捕捉异常信息
      FailCallBackFunc(err);
    });

  }

};

export default NetUtils;



// WEBPACK FOOTER //
// ./src/resources/utils/net-utils.js